import type { BaseTheme } from "common/BaseTheme";
import type { CoreTheme } from "sharedUI/styles";
import { useTheme } from "styled-components";
import type { WireAppTheme } from "webapp/lib/theme/theme";

export function useWireAppTheme() {
    return useTheme() as WireAppTheme;
}

export function useCoreTheme() {
    return useTheme() as CoreTheme & BaseTheme;
}
